module.exports = __webpack_public_path__ + "img/ContentTextBlock.abfb757f.png";